import {Button, Form} from "antd";
import {useTranslation} from "react-i18next";
export interface SubmitProps{
    labelKey:string
}
export function Submit(props:SubmitProps){
    const {t} = useTranslation();
    return <>
        <Form.Item>
            <Button type="primary" htmlType="submit">
                {t(props.labelKey)}
            </Button>
        </Form.Item>
    </>
}